import clsx from 'clsx'

const fmt = n => (n == null ? '—' : Number(n).toLocaleString('pt-BR'))

const Slot = ({ icon, value, label, compact = false }) => (
  <div className={clsx('flex flex-1 items-center gap-2 px-4', compact ? 'py-2' : 'py-3')}>
    <span className={clsx('leading-none', compact ? 'text-lg' : 'text-xl')} aria-hidden>
      {icon}
    </span>
    <div className="min-w-0">
      <p
        className={clsx(
          'm-0 font-black leading-tight text-white',
          compact ? 'text-sm' : 'text-base'
        )}
      >
        {fmt(value)}
      </p>
      {/* white/60 sobre o gradiente do hero não fecha 4.5:1 — /80 fecha. */}
      <p className="m-0 truncate text-2xs text-white/80">{label}</p>
    </div>
  </div>
)

const Divider = () => (
  <div className="w-px self-stretch bg-white/15 my-2" aria-hidden />
)

/**
 * Faixa de stats do hero do Feed Social. Só entram números que a api entrega:
 * havia um slot "online" que nenhuma tela preenchia e que por isso exibia "—"
 * fixo — quando existir uma fonte de presença, ele volta.
 *
 * postCount: total de publicações
 * commentCount: total de comentários
 */
export const FeedStatBar = ({ postCount = 0, commentCount = 0, compact = false }) => (
  <div className="flex items-stretch bg-white/10 backdrop-blur-sm">
    <Slot icon="🔥" value={postCount} label="publicações" compact={compact} />
    <Divider />
    <Slot icon="💬" value={commentCount} label="comentários" compact={compact} />
  </div>
)
